import {Layer} from '../../../service/Layer'
import {Project} from '../../../service/Project'
import {Menu} from '../../../service/Menu'
import {SubMenu} from '../../../service/SubMenu'

const addColumn = async (context, column, aggregation = 'none') => {
  const select = context.state.layers[context.state.activeLayerId].draft.select
  let foundKey = column.hasOwnProperty('id') ? column.id : column.objectId
  foundKey = column.hasOwnProperty('targetId') && column.targetId !== -1 ? column.targetId : foundKey
  const columnIndex = select.findIndex(c => c.id === foundKey)
  if (columnIndex !== -1) return false
  const newColumn = {
    'id': foundKey,
    'useAlias': false,
    'aggregation': aggregation,
    'useInternalName': true,
    'isSystem': true
  }
  const columns = [...select, newColumn]
  context.commit('setColumns', columns)
}
const addLayer = ({ commit }, {layer, style, position}) => {
  commit('addLayer', {layer, style, position})
}
const addLayers = ({ commit }, layers) => {
  layers.forEach(layer => {
    const style = layer.style
    const position = 0
    commit('addLayer', {layer, style, position})
  })
}
const removeLayer = ({ commit }, layerId) => {
  commit('removeLayer', layerId)
}
const removeColumn = async (context, column) => {
  const draft = context.state.layers[context.state.activeLayerId].draft
  const select = draft.select
  let foundKey = column.hasOwnProperty('id') ? column.id : column.objectId
  foundKey = column.hasOwnProperty('targetId') && column.targetId !== -1 ? column.targetId : foundKey
  const columnIndex = select.findIndex(c => c.id === foundKey)
  if (columnIndex !== -1) select.splice(columnIndex, 1)
  if (select.length === 1) {
    const groupIndex = draft.groupBy.findIndex(c => c.id === select[0].id)
    if (groupIndex !== -1) draft.groupBy.splice(groupIndex, 1)
  }
  context.commit('setColumns', select);
}
const activateLayer = (context, layerId) => {
  context.commit("initializeLayer", layerId)
  context.commit("setActiveLayer", layerId)
}
const saveLayer = async (context, payload) => {
  return new Promise((resolve, reject) => {
    const backEnd = Layer.build({})
    backEnd.update(payload).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.commit('setFeatureLayer', payload)
        resolve(res)
      }
    }).catch(error => {
      console.log(error)
      reject(error)
    })
  })
}
const saveLayerOptions = async ({ commit }, { environmentId, layerUid, options }) => {
  try {
    const backEnd = Layer.build({})
    await backEnd.updateJbData(environmentId, layerUid, options)
    // commit('setFeatureLayer', payload)
  }catch (error) {
    console.log(error)
  }
}
const setBaseLayer = async (context, payload) => {
  context.state.baseLayer = payload
  if (payload !== null) {
    if (payload.cClass === 'userdraw') return false
    const layerId = payload.objectid
    const backEnd = Layer.build({})
    await backEnd.getPrimaryKey(layerId).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.state.basePk = res.data[0]
      }
    })
  }
}
const setTargetLayer = async (context, payload) => {
  context.state.targetLayer = payload
  if (payload !== null) {
    if (payload.cClass === 'userdraw') return false
    const layerId = payload.objectid
    const backEnd = Layer.build({})
    await backEnd.getPrimaryKey(layerId).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.state.targetPk = res.data[0]
      }
    })
  }
}
const deleteLayer = async ({ commit }, {layerId}) => {
  const backEnd = Layer.build({})

  try {
    await backEnd.delete(layerId)
    commit('deleteLayer', { layerId })
    return true
  } catch (error) {
    throw error
  }
}
const demoteLayer = async ({ getters, commit, dispatch }, { environmentId, layerId, isUpload }) => {
  try {
    const backEnd = SubMenu.build({})
    let environmentDataMenu = getters.getEnvironmentDataMenu
    if (environmentDataMenu === -1) {
      const res = await backEnd.getMenu(environmentId)
      environmentDataMenu = res.data.objectid
    }
    await backEnd.deleteByLayer(environmentDataMenu, layerId)
    const layer = isUpload ? getters.getUploadLayer(layerId) : getters.getLayer(layerId)
    commit('setEnvironmentDataMenu', environmentDataMenu)
    commit('togglePromotion', { layerId, isUpload })
    dispatch('saveLayer', isUpload ? layer.object.layer : layer.Origin)
  } catch (error) {
    throw error
  }
}
const promoteLayer = async ({ getters, commit, dispatch }, { environmentId, layerId, isUpload }) => {
  const backEnd = Menu.build({})
  const backEnd2 = SubMenu.build({})

  try {
    await backEnd.getSubmenuByLayer(layerId).then(async (res) => {
      if (res.status === 200) {
        const parentId = res.data[0].submenuid
        await backEnd2.getSubMenu(parentId).then(async (res2) => {
          if (res2.status === 200) {
            const parentSubMenu = res2.data
            let environmentDataMenu = getters.getEnvironmentDataMenu
            if (environmentDataMenu === -1) {
              const res3 = await backEnd2.getMenu(environmentId)
              environmentDataMenu = res3.data.objectid
            }
            const layer = isUpload ? getters.getUploadLayer(layerId) : getters.getLayer(layerId)
            const payload = {
              "menuId": environmentDataMenu,
              "environmentId": environmentId,
              "name": layer.name,
              "description": layer.name,
              "layerId": layerId,
              "position": 1,
              "jbData": parentSubMenu.jbData
            }
            //Garantindo allowPreview (Ferraz)
            payload.jbData.allowPreview = true
            await backEnd2.create(payload)
            commit('setEnvironmentDataMenu', environmentDataMenu)
            commit('togglePromotion', {layerId, isUpload})
            dispatch('saveLayer',  isUpload ? layer.object.layer : layer.Origin)
            return true
          }
        })
      }
    })
  } catch (error) {
    throw error
  }
}
const removeReference = async ({ commit }, { projectId, layerId }) => {
  const backEnd = Project.build({})

  try {
    await backEnd.deleteLayer(projectId, layerId)
    commit('removeReference', { layerId })
    return true
  } catch (error) {
    throw error
  }
}
const renameLayer = async ({ getters, commit }, {layerId, newName, isUpload}) => {
  const backEnd = Layer.build({})

  try {
    newName = getters.findNameCollision(newName, layerId)
    await backEnd.rename(null, layerId, newName)
    commit('renameLayer', { layerId, newName, isUpload })
    return true
  } catch (error) {
    throw error
  }
}
const toggleVisibility = ({ commit }, layerId) => {
  commit('toggleVisibility', layerId)
}

export default {
  activateLayer,
  addColumn,
  addLayer,
  addLayers,
  deleteLayer,
  demoteLayer,
  promoteLayer,
  removeColumn,
  removeLayer,
  removeReference,
  renameLayer,
  saveLayer,
  saveLayerOptions,
  setBaseLayer,
  setTargetLayer,
  toggleVisibility
}
